import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "./api";

export function useConsejoExcluidos() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/sales/consejo-excluidos").then((r) => setItems(r.data.excluidos)).catch(() => {}), []);
  useEffect(() => {
    load();
    window.addEventListener("consejo-excluidos-cambio", load);
    return () => window.removeEventListener("consejo-excluidos-cambio", load);
  }, [load]);
  const set = new Set(items.map((i) => i.cn));
  const toggle = async (cn, descripcion) => {
    try {
      if (set.has(cn)) {
        await api.delete(`/sales/consejo-excluidos/${cn}`);
        toast.success("Vuelve a contar como consejo en todos los meses (se recalcula en unos segundos)");
      } else {
        await api.post("/sales/consejo-excluidos", { cn, descripcion });
        toast.success("Excluido: ya no cuenta como consejo ni aparece en ningún mes (se recalcula en unos segundos)");
      }
      window.dispatchEvent(new Event("consejo-excluidos-cambio"));
    } catch {
      toast.error("No se pudo guardar el cambio");
    }
  };
  return { items, set, toggle, reload: load };
}
